/** Format nav badge counts — plan/22 inbox + plan/32 approvals. */

export function navBadgeLabel(label: string, count: number): string {
  if (!Number.isFinite(count) || count <= 0) return label;
  const n = count > 99 ? "99+" : String(Math.floor(count));
  return `${label} (${n})`;
}

export function moreMenuBadgeCount(input: {
  inboxUnread: number;
  approvalsPending: number;
  showInbox: boolean;
  showApprovals: boolean;
}): number {
  let n = 0;
  if (input.showInbox) n += Math.max(0, input.inboxUnread);
  if (input.showApprovals) n += Math.max(0, input.approvalsPending);
  return n;
}
